// src/ConfirmSignUpScreen.js
import React, { useState, useEffect } from 'react';
import { confirmSignUp, resendSignUpCode } from '@aws-amplify/auth/cognito';
import styles from './ChatApp.module.css';

const ConfirmSignUpScreen = ({ onConfirmSuccess, onNavigateToLogin, defaultEmail = '' }) => {
    const [email, setEmail] = useState(defaultEmail);
    const [code, setCode] = useState('');
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setEmail(defaultEmail);
    }, [defaultEmail]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        setIsLoading(true);
        try {
            await confirmSignUp({
                username: email,
                confirmationCode: code
            });
            setMessage('Account confirmed successfully! Redirecting to login...');
            setTimeout(() => {
                onConfirmSuccess();
            }, 2000);
        } catch (err) {
            setError(err.message || 'Invalid code or email.');
            setIsLoading(false);
        }
    };

    const handleResendCode = async () => {
        setError('');
        setMessage('');
        if (!email) {
            setError('Please enter your email address first.');
            return;
        }
        try {
            await resendSignUpCode({ username: email });
            setMessage('A new confirmation code has been sent to your email.');
        } catch (err) {
            setError(err.message || 'Failed to resend code.');
        }
    };

    return (
        <div className={styles.loginContainer}>
            <form className={styles.loginBox} onSubmit={handleSubmit}>
                <div className={styles.loginLogo}>AirGrocer AI</div>
                <h2>Confirm Your Account</h2>
                <p style={{ color: 'var(--text-light)', fontSize: '14px', marginTop: '-15px', marginBottom: '20px' }}>
                    A confirmation code was sent to your email.
                </p>
                {message && <div className={styles.adminSuccess} style={{textAlign: 'left', marginBottom: '15px'}}>{message}</div>}
                {error && <div className={styles.adminError} style={{textAlign: 'left', marginBottom: '15px'}}>{error}</div>}
                <input
                    type="email"
                    placeholder="Email"
                    className={styles.loginInput}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled={isLoading}
                />
                <input
                    type="text"
                    placeholder="Confirmation Code"
                    className={styles.loginInput}
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    required
                    disabled={isLoading}
                />
                <button type="submit" className={styles.loginButton} disabled={isLoading}>
                    {isLoading ? 'Confirming...' : 'Confirm Account'}
                </button>
                <div className={styles.signUpLink} style={{marginTop: '15px'}}>
                    <button type="button" onClick={handleResendCode} className={styles.linkButton}>
                        Resend Code
                    </button>
                </div>
                <div className={styles.signUpLink} style={{marginTop: '10px'}}>
                    <button type="button" onClick={onNavigateToLogin} className={styles.linkButton}>
                        &larr; Back to Login
                    </button>
                </div>
            </form>
        </div>
    );
};

export default ConfirmSignUpScreen;